<div class="card">
    <slot></slot>
</div>

<style>
    .card {
        background-color: #fff;
        color: #333;
        border-radius: 15px;
        padding: 40px 50px;
        margin-block: 20px;
        position: relative;
    }
</style>